import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'spb-core-button',
  template: '',
  encapsulation: ViewEncapsulation.None
})
export class ButtonComponent {

  @Input() type: string;
  @Input() disabled: boolean;
  @Output() buttonClick: EventEmitter<any> = new EventEmitter();
  @Output() buttonFocus: EventEmitter<any> = new EventEmitter();

  constructor() { }
}
